'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _App = require('./components/App.js');

var _App2 = _interopRequireDefault(_App);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $iconLibrary = document.getElementById('ip-icon-library');

if ($iconLibrary) {
	// Grab the context
	var context = $iconLibrary.getAttribute('data-context');
	var active = $iconLibrary.getAttribute('data-active');
	// render app
	_reactDom2.default.render(_react2.default.createElement(_App2.default, { context: context, active: active }), $iconLibrary);
}


//////////////////
// WEBPACK FOOTER
// ./src/index.js
// module id = 100
// module chunks = 0 1